<template>
  <div class="home">
<div class="works">
	<div class="works-ban">
		<h2>新聞中心</h2>
		<p>主頁 / 新聞中心</p>
	
	</div>
	<div class="home-ct">
<div class="news">

	<div class="con">
	<ul>
		<li v-for="item in data">
			<router-link :to="'details?id='+item.id">
			<div class="pic">
				<img :src="item.originalPic" />
			</div>
			<div class="txt">
				<div class="l1">
					
					<div class="time"><div class="ic"></div>{{item.dtTime}}</div>
					<div class="add">新聞</div>
					 
				</div>
				<div class="l2">
					{{item.title}}
				</div>
				<div class="l3">
					{{item.remark.substring(0,50)}}……
				</div>
			</div>
			</router-link>
		</li>

		<div class="clear"></div>
	</ul>
	</div>
</div>
	
 
	
		
		</div>
</div>
  
    </div>
</template>
<script>


export default {

  data() {
    return {

    data:[],
	channel_id:2,
	ruleForm: {
		name:'',
		email:'',     
		phone:'',
		company:'',
		message:''
		
	    
	      }
    };
  },
 mounted() {
	  

		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },
	sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsList",
			  data: {content_len:'60',channel_id:this.channel_id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
			
									
					this.data=data.data;
					
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},	 submitForm(formName) {
		
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_contactUs",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		}
};
</script>
<style lang="scss" scoped>
.han-tab{
	margin-top: 20px;
}
.news{
	li{
		width: 31%;
		height: 290px;
		margin: 30px 1%;
		float: left;
		.pic{
			height: 210px;
			overflow: hidden;
			img{
				width: 100%;
				transition: all 0.5s;
			}
			img:hover{
				 transform: scale(1.2);
			}
		}
		.l1{
			display: flex;
			align-items: center;
			line-height: 50px;
			font-size: 14px;
			justify-content: space-between;
			.ic{
				width: 48px;
				height: 1px;
				background: #D2D2D2;
				margin-right: 10px;
			}
			.time{
				color: #A4A4A4;
				display: flex;
				align-items: center;
			}
			.add{
				color: #B70000;
			}
		}
		.l2{
			font-size: 18px;
			color: #000000;
			height: 20px;
			overflow: hidden;
			text-transform: uppercase
		}
		.l3{
			font-size: 14px;
			color: #666666;
			margin-top: 10px;
			line-height: 20px;
			
		}
	}
	
}
.works{


	.works-ban{
		padding-top: 30px;
		background: #0A0A0A;
		height: 107px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
		}
		p{
			font-size: 18px;
		}
	}

}

</style>